export const OrderBy = {
    sessions: 'sessions',
    listeningTime: 'listeningTime',
    alias: 'alias',
    uniqueListeners: 'uniqueListeners',
};

export const OrderDirection = {
    desc: 'DESC',
    asc: 'ASC',
}; 